import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, deleteCompany } from '@/api/PMS/baseInformation/customer';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
import waves from '@/directive/waves'; // 水波纹指令

import customerAdd from './add';
import customerDetail from './detail';
import bindHouse from './bindHouse';
export default {
  components: {
    customerAdd: customerAdd,
    customerDetail: customerDetail,
    bindHouse: bindHouse
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      dialogHouse: false,
      typeOption: [],
      options: [],
      searchId: [],
      cascaderItem: [],
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      listQuery: {
        page: 1,
        limit: 10,
        dataType: '',
        customerName: '',
        customerType: 2,
        id: ''
      },
      title: '',
      customerId: '',
      multipleSelection: [],
      dialogFormVisible: false,
      dialogDetailFormVisible: false
    };
  },
  watch: {
    searchId: function searchId(val) {
      this.listQuery.id = val[val.length - 1];
    },
    deep: true
  },
  created: function created() {
    this.typeOption = [];
    this.cascaderItem = [];
    this.getList();
    this.loadMenuTree();
    this.loadTypeOptions();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogDetailFormVisible = false;
      this.dialogFormVisible = false;
      this.dialogHouse = false;
    },
    // 获取具体的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    handTreeSelect: function handTreeSelect(val) {
      this.cascaderItem = [];
      this.getCascaderItem(this.searchId, this.options);
      this.listQuery.dataType = this.cascaderItem[this.cascaderItem.length - 1].flag;
      console.log(this.listQuery.dataType);
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    // changeTypeValue(val) {
    //   let obj = {}
    //   obj = this.locations.find(item => {
    //     return item.customerType === val
    //   })
    //   this.listQuery.customerType = obj.dicName
    // },
    loadTypeOptions: function loadTypeOptions() {
      var _this3 = this;

      fetchListByType('customer_type').then(function (r) {
        _this3.typeOption = r.data.data;
      });
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true; // this.listQuery.isRent = 1

      this.listQuery.customerType = 2; // this.listQuery.flag = 1

      fetchList(this.listQuery).then(function (response) {
        _this4.list = response.data.data;
        _this4.total = response.data.total;
        _this4.listLoading = false;
      });
    },
    getStr: function getStr(str) {
      if (str) return str.substring(0, 10);else return str;
    },
    gethouseList: function gethouseList(data) {
      var houseName = [];
      var houseName1 = '';

      if (data) {
        console.log(data, 'll');
        data.forEach(function (item) {
          houseName.push(item.houseName);
          console.log(item.houseName);
        });
        return houseName.toString();
      } else {
        console.log('ssss');
      } // var houseName = []
      // data.forEach(item => {
      //   houseName.push(item.houseName)
      // })

    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDetails: function handleDetails(customerId) {
      this.customerId = customerId;
      this.title = '详情';
      this.dialogDetailFormVisible = true;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.customerId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(customerId) {
      console.log(customerId, '000...');
      this.customerId = customerId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    // 绑定房屋
    handleBind: function handleBind(customerId) {
      this.customerId = customerId;
      this.title = '绑定房屋';
      this.dialogHouse = true;
    },
    delete: function _delete(customerIds) {
      var _this5 = this;

      if (customerIds.length > 0) {
        this.$confirm('你确定是要删除这些客户, 是否继续?', '提示').then(function () {
          deleteCompany(customerIds).then(function (response) {
            _this5.getList();

            _this5.$emit('refreshTree');

            _this5.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(customerId) {
      var customerIds = [];
      customerIds.push(customerId);
      this.delete(customerIds);
    },
    handleDeletes: function handleDeletes() {
      var customerIds = [];
      this.multipleSelection.forEach(function (row) {
        customerIds.push(row.companyId);
      });
      this.delete(customerIds);
    }
  }
};